import React from "react";
import { FiChevronRight } from "react-icons/fi";
import CarCrashIcon from "@mui/icons-material/CarCrash";
import { Booking } from "../../../../../logic/api";
import { countVehicleIssues } from "../../../../../utility/assetIssues";
import { useDate } from "../../../../../utility/useDate";
import { fullVehicleDescription, locationDescription, parseVehicleStatus } from "../condensedLayoutUtils";
import styles from "../styles";
import { useTranslation } from "react-i18next";

const VehicleRow: React.FunctionComponent<{
    booking: Booking,
    allocatedNotPresent?: boolean,
    rowIndex: number,
    onClick: () => void
}> = (props) => {
    const { toFormattedFullDateTimeString } = useDate();
    const { booking, rowIndex } = props;
    const { ref, vehicle, expectedReturnDate, vehicleAuditIssues } = booking;
    const { statusId, location, registration, row } = vehicle;
    const rowStyles = {
        ...(rowIndex % 2 ? styles.tableRowOdd : styles.tableRowEven),
        cursor: "pointer",
    };
    const { t } = useTranslation();

    const fadeFilter = props.allocatedNotPresent ? { opacity: "55%" } : {};

    return (<tr data-testid={`vehicle-row-${props.booking.id}`} style={{ ...fadeFilter, ...rowStyles }} onClick={props.onClick}>
        <td style={styles.tableCell}>{parseVehicleStatus(statusId)}</td>
        <td style={styles.tableCell}>{ref}</td>
        <td style={styles.tableCell}>{locationDescription(location)}</td>
        <td style={styles.tableCell}>{row ? t("locations.row", { row: row }) : "-"}</td>
        <td style={styles.tableCell}>{registration}</td>
        <span style={{ ...styles.tableCell, display: "inline-block", marginLeft: -24, marginTop: 4, width: 24 }}>{countVehicleIssues(vehicleAuditIssues) ? <CarCrashIcon style={{ color: "rgb(235, 48, 79)" }} /> : ""}</span>
        <td style={styles.tableCell}>{fullVehicleDescription(vehicle)}</td>
        <td style={styles.tableCell}>{toFormattedFullDateTimeString(new Date(expectedReturnDate))}</td>
        <td style={styles.tableCell}><FiChevronRight /></td>
    </tr>)
}

export default VehicleRow;
